// extracted by mini-css-extract-plugin
export default {"container":"TargetSelectorArea_container__cgOq3"};